import Trivia from "./Trivia";
export default Trivia;
